import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  AccordionSummaryProps,
  AccordionProps,
} from "@mui/material";
import Flex from "./Flex";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ReactNode } from "react";

interface CustomAccordionProps {
  rightSection?: ReactNode;
  accordionSummaryContent: ReactNode;
  accordionDetailsContent: ReactNode;
  expanded?: boolean;
  accordionSummeryProps?: AccordionSummaryProps;
  onClickHandler?: () => void;
  showExpandIcon?: boolean;
  expandIconOnRight?: boolean;
  accordionProps?: Omit<AccordionProps, "children">;
}

const CustomAccordion = ({
  rightSection,
  accordionSummaryContent,
  accordionDetailsContent,
  expanded,
  accordionSummeryProps,
  onClickHandler,
  showExpandIcon = true,
  expandIconOnRight = false,
  accordionProps,
}: CustomAccordionProps) => {
  return (
    <Accordion
      expanded={expanded}
      sx={{ boxShadow: "none", ...accordionProps?.sx }}
      {...accordionProps}
    >
      <AccordionSummary
        disableRipple
        onClick={(e: any) => {
          if (
            e.target.className?.includes("MuiButtonBase-root") ||
            e.target.className?.includes("MuiBackdrop-root")
          )
            return;

          onClickHandler?.();
        }}
        {...accordionSummeryProps}
        expandIcon={
          showExpandIcon ? (
            <ExpandMoreIcon
              sx={{ cursor: "pointer" }}
              onClick={() => onClickHandler?.()}
            />
          ) : undefined
        }
        sx={{
          color: "primary.main",
          bgcolor: "#1A1A1A0D",
          height: "20px",
          "&.Mui-expanded": {
            minHeight: "30px",
          },
          minHeight: "30px",
          ...(expandIconOnRight && {
            "& .MuiAccordionSummary-expandIconWrapper": {
              transform: "rotate(0deg)",
              marginLeft: "auto",
              transition: "transform 0.2s",
            },
            "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
              transform: "rotate(180deg)",
            },
          }),
        }}
      >
        <Flex
          width={"100%"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          {accordionSummaryContent}
          {rightSection}
        </Flex>
      </AccordionSummary>
      <AccordionDetails style={{ padding: 0 }}>
        {accordionDetailsContent}
      </AccordionDetails>
    </Accordion>
  );
};

export default CustomAccordion;
